
declare let $: any;
export class ChangedObject {
  static parse(amendment, root) {
    let object: any = this.compare(amendment, root, {});
    return object;
  }
 static checkChange(amendment, root) {
    const result = this.compare(amendment, root, {});
    return Object.keys(result).length;
  }
  
  private static compare(newObject, oldObject, resultObject) {
      if (newObject  instanceof Array || oldObject  instanceof Array) {
        let length = newObject.length > oldObject.length ? newObject.length : oldObject.length;
        for (let i= 0 ; i < length; i++) {
          !newObject[i] && (newObject.push(null));
          !oldObject[i] && (oldObject.push(null));
        }
      }
      if (!oldObject) {
        if (!newObject) {
          return resultObject;
        } else {
          return newObject;
        }
        
      }
      if (!newObject) {
        return resultObject;
      }
      let object = {}, isFind = false;
      if (oldObject instanceof Array) {
        object = [];
      }
      for (let property in oldObject) {
        if (property !=  'errors' && property !=  'texts' && property != 'expiredDate') {
          if (typeof oldObject[property] === 'object') {
              let result = this.compare(newObject[property], oldObject[property], object[property]);
              if (result) {
                  isFind = true;
                  object[property] = result;
              }
          } else if (newObject[property] != oldObject[property] && property != 'index' && property != 'active')  {
              isFind = true;
              object[property] = newObject[property];
          }
        }
      }
      if (isFind) {
          resultObject = object;
      }
      return resultObject;
  }
}